"use client";

import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Legacy() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const pullStats = [{
    label: "FOUNDED",
    value: "2026"
  }, {
    label: "REPRESENTATION",
    value: "4+ Firms"
  }];
  return <section data-section-id="11557" id="our-industrial-legacy" className="bg-background text-foreground py-28 md:py-40">
      <div className="mx-auto max-w-[1280px] px-6 sm:px-10 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-x-[88px] items-start">
          {}
          <div ref={leftRef} className="lg:col-span-7 order-2 lg:order-1" style={{
          opacity: leftVisible ? 1 : 0,
          transform: leftVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 700ms cubic-bezier(0.2,0.7,0.2,1), transform 700ms cubic-bezier(0.2,0.7,0.2,1)"
        }}>
            {}
            <div className="h-px w-16 bg-border mb-8" />

            {}
            <p className="font-default text-[0.8125rem] font-medium uppercase text-muted-foreground mb-8" style={{
            letterSpacing: "0.16em"
          }}>
              Our Industrial Legacy
            </p>

            {}
            <h1 className="font-default font-bold text-foreground" style={{
            fontSize: "clamp(2.75rem, 5.2vw, 4.75rem)",
            lineHeight: 1.04,
            letterSpacing: "-0.018em"
          }}>
              Sales is a technical <em className="font-default italic font-normal text-primary">discipline</em>, not a volume game.
            </h1>

            {}
            <div className="mt-10 space-y-6 max-w-[44rem]">
              <p className="font-default font-normal text-foreground/80" style={{
              fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
              lineHeight: 1.55
            }}>
                MetPro Partners was built on the premise that industrial buyers require technical fluency, not just sales scripts. We represent elite manufacturers by bridging the gap between complex engineering capabilities and the specific needs of the automotive, metal fabrication, and shipbuilding sectors.
              </p>
              <p className="font-default font-normal text-foreground/80" style={{
              fontSize: "clamp(1.0625rem, 1.15vw, 1.1875rem)",
              lineHeight: 1.55
            }}>
                Our approach is rooted in long-term partnership. We don't just move units; we integrate into your sales cycle, providing the credibility and technical depth required to secure high-stakes contracts in demanding industrial environments.
              </p>
            </div>

            {}
            <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 gap-10 sm:gap-12 max-w-[36rem]">
              {pullStats.map((stat, i) => <div data-index={i} key={stat.label}>
                  <div className="h-px w-12 bg-border mb-5" />
                  <p className="font-mono text-[0.75rem] font-medium uppercase text-muted-foreground mb-3" style={{
                letterSpacing: "0.16em"
              }}>
                    {stat.label}
                  </p>
                  <p className="font-default font-bold text-foreground" style={{
                fontSize: "clamp(1.75rem, 2.6vw, 2.5rem)",
                lineHeight: 1.05,
                letterSpacing: "-0.014em"
              }}>
                    {stat.value}
                  </p>
                </div>)}
            </div>
          </div>

          {}
          <div ref={rightRef} className="lg:col-span-5 order-1 lg:order-2 w-full" style={{
          opacity: rightVisible ? 1 : 0,
          transform: rightVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 700ms cubic-bezier(0.2,0.7,0.2,1) 80ms, transform 700ms cubic-bezier(0.2,0.7,0.2,1) 80ms"
        }}>
            {}
            <div className="block lg:hidden">
              <div className="overflow-hidden rounded-lg group">
                <AspectRatio ratio={4 / 3}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_precision_machining.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_precision_machining.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_precision_machining.webp-wvc-sizes" alt="Precision metal machining process in an industrial facility" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />
                </AspectRatio>
              </div>
            </div>
            <div className="hidden lg:block">
              <div className="overflow-hidden rounded-lg group">
                <AspectRatio ratio={4 / 5}>
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_precision_machining.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_precision_machining.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1705670/img/industrial_precision_machining.webp-wvc-sizes" alt="Precision metal machining process in an industrial facility" loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[600ms] ease-out group-hover:scale-[1.03]" />
                </AspectRatio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}